module.exports = __webpack_public_path__ + "static/digital_card_passport-9c2036dfcad164e64a1783120a91e4e3.pdf";